import axios from "axios";
import { parseCookies } from "nookies";

// Helper to handle 401 errors globally
const handle401Error = (error) => {
  if (error.response?.status === 401) {
    // Trigger logout and redirect via window event
    window.dispatchEvent(new CustomEvent('auth:logout', { detail: { reason: 'Session expired' } }));
  }
  return error;
};

export const postFormDataSetupProfileApiCaller = async (endPoint, formData) => {
  const cookies = parseCookies(); // Get cookies
  const setupProfileToken = cookies.token;
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${setupProfileToken}`,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const postFormDataApiCaller = async (endPoint, formData) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  
  console.log('[API CALLER] Starting POST request', {
    endpoint: endPoint,
    baseUrl,
    hasToken: !!token,
    formDataKeys: Array.from(formData.keys())
  });

  try {
    const url = baseUrl + endPoint;
    console.log('[API CALLER] Sending request to:', url);
    
    const response = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
      timeout: 60000, // 60 second timeout for file uploads
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(`[API CALLER] Upload progress: ${percentCompleted}%`, {
            loaded: progressEvent.loaded,
            total: progressEvent.total
          });
        }
      },
    });
    
    console.log('[API CALLER] Request successful', {
      status: response.status,
      statusText: response.statusText,
      data: response.data
    });
    
    return response;
  } catch (error) {
    const errorDetails = {
      endpoint: endPoint,
      url: baseUrl + endPoint,
      errorMessage: error.message,
      errorCode: error.code,
      responseStatus: error.response?.status,
      responseStatusText: error.response?.statusText,
      responseData: error.response?.data,
      responseHeaders: error.response?.headers,
      requestHeaders: error.config?.headers,
      requestData: error.config?.data,
    };
    
    // Log response data in a more readable format
    if (error.response?.data) {
      console.error('[API CALLER] Server error response:', JSON.stringify(error.response.data, null, 2));
    }
    
    console.error('[API CALLER] Request failed', errorDetails);
    
    handle401Error(error);
    return error;
  }
};
export const putFormDataApiCaller = async (endPoint, formData) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  try {
    const url = baseUrl + endPoint;
    const response = await axios.put(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

export const postApiCaller = async (endPoint, body) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, body, { headers: header });
    return response;
  } catch (error) {
    handle401Error(error);
    return error;
  }
};
export const postApiCallerForgotPassword = async (endPoint, body) => {
  const token = localStorage.getItem("accessToken");
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.post(url, body, { headers: header });
    return response;
  } catch (error) {
    return error;
  }
};

export const getApiCaller = async (endPoint) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.get(url, { headers: header });
    return response;
  } catch (error) {
    handle401Error(error);
    return error;
  }
};

export const putApiCaller = async (endPoint, body) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.put(url, body, { headers: header });
    return response;
  } catch (error) {
    handle401Error(error);
    return error;
  }
};

export const deleteApiCaller = async (endPoint) => {
  const cookies = parseCookies(); // Get cookies
  const token = cookies.accessToken; // Retrieve token
  const baseUrl = process.env.REACT_APP_PUBLIC_BASE_URL;
  let header = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const url = baseUrl + endPoint;
    const response = await axios.delete(url, { headers: header });
    return response;
  } catch (error) {
    handle401Error(error);
    return error;
  }
};
